import 'datatables.net-dt/css/jquery.dataTables.css'
import 'datatables.net-buttons-dt/css/buttons.dataTables.css'
import pdfMake from "pdfmake/build/pdfmake";
import pdfFonts from "pdfmake/build/vfs_fonts";

import React, {Component} from 'react';
import {translate} from 'react-i18next';
import swal from 'sweetalert';
import moment from 'moment';

const $ = require('jquery');
$.DataTable = require('datatables.net-dt');

require('datatables.net-buttons/js/dataTables.buttons.min' );

pdfMake.vfs = pdfFonts.pdfMake.vfs;

const jzip = require( 'jszip');
require( 'datatables.net-buttons/js/buttons.html5.min' );
window.JSZip = jzip;

var session = sessionStorage.getItem('health_facilities_name');
var Config = require('../../../config');
var report = require('../../generics/report_head');

class MadeCrio extends Component{
	constructor(props){
		super(props);

		this.handleChange = this.handleChange.bind(this);
		this.searching = this.searching.bind(this);
		this.isValidForm = this.isValidForm.bind(this);
		this.showCtrlError = this.showCtrlError.bind(this);
		//this.checking = this.checking.bind(this);
		this.dateCompare = this.dateCompare.bind(this);

		this.setTable = this.setTable.bind(this);

		this.state = {
			health_facilities_id:"",
			health_facilities: [],

			start_date 	:"",
			end_date 	:"",
			start_folio:"",
			end_folio:"",
			search_type:"date",

			listado:[],

			change_check: false,
			columns:[
				{title:'No. UNIDAD'},
				{title:'FECHA'},
				{title:'COMPONENTE ORIGINAL'},
				{title:'GRUPO & RH'},
				{title:'COMPONENTES OBTENIDOS'},
				{title:'USUARIO'},
				
			],
			totales:[],
			filename:'Crioprecipitados Realizados',
			rhGroup:[],
			group:"all",
			date_hour:"",
			medical:"",
			option:"all",
			total_don:"",
			total_ext:""
		}
	}

	componentWillMount(){
		var medical = JSON.parse(sessionStorage.getItem('medical_staff'));

		this.setState({
			health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			medical:(medical.lastname1 !== null ? medical.lastname1 : "")+' '+
					(medical.lastname2 !== null ? medical.lastname2 : "")+' '+medical.names
		});

		if(!this.props.hiddeToReport){
			this.props.reload();
		}
	}

	componentDidMount(){
		this.props.waiting.handleShow('Cargando...');
		setTimeout(()=>{
			this.props.waiting.handleClose();
		}, 300)

		/*fetch(Config.default.apiGateway.URL+'health_facilities', {
			method: 'GET',
			headers: new Headers({
				'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
				'Accept'		: 'application/json',
				'Content-Type'	: 'application/json'
			})
		}).then(res => {
			this.props.waiting.handleClose();
			if(res.ok){
				return res.json();
			}else{
				res.text().then((msg)=>{
					swal('Error', msg, 'error');
				});
			}
		}).then(response => {
			if(response !== undefined){
				this.setState({
					health_facilities: response
				});
			}
		});

		//grupos sanguineos
		fetch(Config.default.apiGateway.URL+'lookups?type=blood_group_rh',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		       'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			this.setState({
		      rhGroup: response
		    });
		})*/

		fetch(Config.default.apiGateway.URL+'offers?option=date',{ 
		    method: 'get',
		    headers: new Headers({
		       'Authorization': 'Bearer ' + sessionStorage.getItem("token") , 
		       'Accept': 'application/json',
		        'Content-Type': 'application/json',
		    })
		})
		.then(response => response.json())
		.then(response => {
			var aux = response.split('|');
			var date = aux[0].split("/");
			var hours = this.getHourFormat(aux[1]);

			this.setState({
				start_date:date[2]+'-'+date[1]+'-'+date[0],
				end_date:date[2]+'-'+date[1]+'-'+date[0],
				date_hour:aux[0]+' '+hours,
			});
		})


		this.setTable();
	}

	getHourFormat(hr){
		var format = hr.split(' ');
		var hrs    = format[0].split(':');
		var ampm = format.length === 2 ? format[1] : format[1]+' '+format[2];
		var hour = parseInt(hrs[0],10);
		var minute = parseInt(hrs[1],10);
		
		if((ampm === "PM" || ampm === "p. m.") && hour < 12)	hour += 12;

		if((ampm === "AM" || ampm === "a. m.") && hour === 12)	hour -= 12;

		if(hour < 10) hour = '0'+hour;

		if(minute < 10) minute = '0'+minute;
		var nvaHour = hour+':'+minute;

		return nvaHour;
	}
	
	setTable(){
		var fechas = this.state.search_type === 'date' ?
			"Información Del: "+(this.state.start_date !== "" ? moment(this.state.start_date).format("DD/MM/YYYY"): '')+ 
			" Al: "+(this.state.end_date !== "" ? moment(this.state.end_date).format("DD/MM/YYYY") : '') 
		: ""
		this.$el = $(this.el);


		var table = this.$el.DataTable({
			dom: 'Bfrtip',
			buttons: [
				{
                	extend: 'excelHtml5',
                	title: this.state.filename
            	},
            	{
                	extend: 'pdfHtml5',
                	title: this.state.filename,
                	customize: (doc)=> { 
                		doc.content.unshift({
							image: this.props.header_document,
							alignment:'center',
							width:this.props.w_head
						});
						doc.content.splice(2, 0, {text: fechas, margin:[10,0,0,10] });
						
                		doc.content[3].table.widths= ['10%', '15%','15%','10%','30%','20%'];
       					
       					this.state.totales.map((t)=>{
       						doc.content.push({text: t.code+': '+t.total});
       					});
						
						doc.content.push({text: 'Donaciones: '+this.state.total_don});
						doc.content.push({text: 'Entradas Externas: '+this.state.total_ext});

                		doc.defaultStyle.fontSize = 6.5;
                		doc.styles.tableHeader.fontSize = 6.5;
                		doc.footer = {text: this.state.date_hour+'\t-\t'+this.state.medical, alignment: 'right',margin: [ 0, 0, 50, 0 ]};
                	} 
            	},
            ],
            /*rowGroup: {
	            dataSrc: [ 0 ],
	            startRender: function ( rows, group ) {
	            	var len = rows.data()[0].length-1
	            	var total = rows
	                    .data()
	                    .pluck(len)[0];	                   
	                
	            	return $('<tr/>')
	                    .append( '<td colspan="'+(len-1)+'">'+group+'</td>' )
	                    .append( '<td>TOTAL: '+total+'</td>' );
	            },
	        },
	        columnDefs: [ {
	            targets: [ 0 ],
	            visible: false
	        } ],*/
			data: this.state.listado,
			columns:this.state.columns,
			
			oLanguage:{
				"sProcessing":"Procesando...",
				"sLengthMenu":"Mostrar _MENU_ registros",
				"sZeroRecords":"No se encontraron resultados",
				"sEmptyTable":"Ningún dato disponible en esta tabla",
				"sInfo":"Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
				"sInfoEmpty":"Mostrando registros del 0 al 0 de un total de 0 registros",
				"sInfoFiltered":"(filtrado de un total de _MAX_ registros)",
				"sInfoPostFix":"",
				"sSearch":"Buscar:",
				"sUrl":"",
				"sInfoThousands":",",
				"sLoadingRecords":"Cargando...",
				"oPaginate":{
					"sFirst":"Primero",
					"sLast":"Último",
					"sNext":"Siguiente",
					"sPrevious":"Anterior"},
					"fnInfoCallback":null,
			},
			paging:false,
			responsive:true,
			searching: false,
			scrollY:"32em",
			scrollX: true,
			autoWidth: false,
			info:false,
			ordering:false,
			/*createdRow: function(row, data, dataIndex){
				var len = data.length-1;
				if(typeof data[len] === 'number'){
					$(row).css('display', 'none');
				}
            }*/
		});

		if (table.rows().indexes().length === 0 ) {
			table.buttons('.buttons-html5').disable();
		}else {
			table.buttons('.buttons-html5').enable();
		}
	}

	handleChange(e){
		this.setState({
			[e.target.name]: e.target.value
		});

		var control = document.getElementById(e.target.name);
		
		if(control.required && control.className.includes('error')){
			control.classList.remove('error');
		}

		/*if(e.target.name === 'search_type'){
			this.setState({
				start_date 	: "",
				end_date 	: "",
				start_folio:"",
				end_folio:"",
			})
		}*/
	}

	searching(){
		if(this.isValidForm()){
			if(this.dateCompare()){
				var obj = {
					start_date:this.state.start_date,
					end_date:this.state.end_date,
					/*start_folio: this.state.start_folio,
					end_folio: this.state.end_folio,
					group: this.state.group !== 'all' ? this.state.group.split(' ')[0] :'all',
					rh: this.state.group !== 'all' ? this.state.group.split(' ')[1] :'all',*/
					health_facilities_id:this.state.health_facilities_id,
					option:this.state.option
				};
				
				this.props.waiting.handleShow('Buscando...');
				fetch(Config.default.apiGateway.URL+'reports/cryoprecipitate_process',{
					method: 'POST',
					body:JSON.stringify(obj),
					headers: new Headers({
						'Authorization'	: 'Bearer '+sessionStorage.getItem('token'),
						'Accept'		: 'application/json',
						'Content-Type'	: 'application/json'
					})
				}).then(res => {
					this.props.waiting.handleClose();
					if(res.ok){
						return res.json();
					}else{
						res.text().then((msg)=>{
							swal('Error', msg, 'error');
						});
					}
				}).then(response => {
					if(response !== undefined){

						this.setState({
							listado: [],
							totales:[],
							//columns:[{title:'COMPONENTE'},{title:'No. UNIDAD'},{title:'GPO & RH'}]
						});
						/*var mayor = 0;
						response.res.map((res)=>{
							res.units.map((u)=>{
								if(u.parts.length > mayor){
									mayor = u.parts.length
								}
							})
						});

						for(var i = 0; i < mayor; i++){
							this.state.columns.push({title:'No. Comp('+(i+1)+')'},{title:'Vol. Comp('+(i+1)+')'})
						}
						this.forceUpdate();
						
						, list_pdf = [];
						response.res.map((r)=>{
							var obj = [], obj_pdf = [];

							obj.push(r.component);
							obj_pdf.push({text:r.component,colSpan:this.state.columns.length-2,bold:1,fillColor:'#dfdfdf'},{})
							for(var i = 0; i < mayor; i++){
								obj.push('','');
								if(i>0)
									obj_pdf.push({},{})
							}
							obj_pdf.push({});
							obj.push('',r.total);
							obj_pdf.push({text:'TOTAL: '+r.total,bold:1,fillColor:'#dfdfdf', alignment:'center'})
							
							
							list.push(obj);
							list_pdf.push(obj_pdf);
							
							r.units.map((u)=>{
								obj = [];
								obj_pdf = [];

								obj.push(u.component, u.unit_number, u.group_rh);
								obj_pdf.push({text:u.unit_number}, {text:u.group_rh, alignment:'center'})

								u.parts.map((p)=>{
									obj.push(p.code, p.volume+' ml')
									obj_pdf.push({text:p.code, alignment:'center'}, {text:p.volume+' ml', alignment:'center'})
								})

								for(var i = u.parts.length; i < mayor; i++){
									obj.push('','','');
									obj_pdf.push({},{},{});
								}

								list.push(obj);
								list_pdf.push(obj_pdf)
							})

						})*/
						var list = []
						response.resp.map((res)=>{
							var obj = [
								res.unit_number,
								moment(res.date).format('DD/MM/YYYY')+' '+
								moment(res.hour, 'H:mm:ss').format('HH:mm'),
								res.component,
								res.g_rh,
							];

							var parts = '';
							res.parts.map((p)=>{
								parts += p.code+'('+p.volume+' ml) '+' ';
							})
							obj.push(parts, res.user);

							list.push(obj);
						})


						setTimeout(()=>{
							this.props.waiting.handleShow('Cargando...');
							this.$el = $(this.el);
							this.$el.DataTable().destroy();
							this.$el.empty();
						}, 500);

						setTimeout(()=>{
							this.props.waiting.handleClose();
							this.setTable();
						}, 1000);

						this.setState({
							listado: list,
							//listado_pdf: list_pdf,
							totales:response.totals,
							total_don:response.total_donation,
							total_ext:response.total_external
						});
						
					}
				});
			}else{
				swal('Error', 'La Fecha Hasta debe ser mayor o igual a Fecha Desde', 'error');
			}
			
		}else{
			swal('Error', 'Campos Incompletos', 'error');
		}
	}

	dateCompare(){
		var ini = moment(this.state.start_date);
		var fin = moment(this.state.end_date);
		var date_ok = true;
		if(this.state.search_type === 'date'){
			if(ini !== 'Invalid date' && fin !== 'Invalid date'){
				if(fin < ini){
					date_ok = false;
					document.getElementById('end_date').classList.add('error');
				}else{
					document.getElementById('end_date').classList.remove('error');
				}
			}else{
				date_ok = false;
			}		
		}

		return date_ok;
	}

	isValidForm() {
		const select = document.querySelector('form');
		const inputs = select.querySelectorAll('input, select');
	    let isFormValid = true;
	    
	    inputs.forEach(input => {
	    	if(input.required){
	    		
		      	const isInputValid = this.showCtrlError(input.name);
		      	if (!isInputValid) {
		        	isFormValid = false;
		    	}
		    	
		   
		  	}
	    });	    

	    return isFormValid;
	}

	showCtrlError(refName) {
		var res = null;
		var control = document.getElementById(refName);
		if (this.state[refName] === "") {

			if(control !== null){
				control.classList.add('error');
			}
			res = false;
		} else{
			if(control !== null){
				if(control.required && control.className.includes('error')){
					control.classList.remove('error');
				}
			}
			res = true;
		}
		

		return res;
	}

	/*checking(e){
		if(this.state.change_check){
			this.setState({
				change_check: false,
				health_facilities_id: sessionStorage.getItem('health_facilities_id'),
			});
		}else{
			this.setState({
				change_check: true,
			});
		}
	}*/


	render(){
		const {t} = this.props;

		return (
			<div className="col-xs-12">
				<div className="route">
					<h5 className="title_page">
					{session} ->
					{t('sidebar.nav.reports.MAIN')} ->
					Procesado ->
					Crioprecipitados
					</h5>
				</div>
				<div className="form-group" style={{paddingLeft:"0.5em"}}>

					<div className="col-xs-12">
						<form noValidate>
							<div className="col-xs-12 col-sm-2" style={{borderRight:"1px solid #e0e0e0"}}>
								
								<div className="form-group">
									<span className="span-min">Fecha Desde</span>
									<input type="date" className="form-control hour-input" name="start_date" id="start_date"
										value={this.state.start_date} onChange={this.handleChange} required />
								</div>
								<div className="form-group">
									<span className="span-min">Fecha Hasta</span>
									<input type="date" className="form-control hour-input" name="end_date" id="end_date"
										value={this.state.end_date} onChange={this.handleChange} required />
								</div>
									
								<div className="form-group">
									<span className="span-min">Fuente</span>
									<select name="option" id="option" value={this.state.option}
										onChange={this.handleChange} className="form-control" required>
										<option value="">Seleccione...</option>
										<option value="all">Todos</option>
										<option value="DONATION">Donaciones</option>
										<option value="ENTRIES">Entradas Externas</option>
									</select>
								</div>
								
								<div style={{textAlign:"right"}}>
									<button type="button" className="btn btn-info" onClick={this.searching} 
										style={{fontSize:"1em"}}>
										Buscar
									</button>
								</div>
							</div>

							<div className="col-xs-12 col-sm-10">
								<div className="col-xs-12">
									<div className="col-xs-12" style={{marginTop:"20px",textAlign: "center",fontWeight: "bold",textDecoration: "underline"}}>
										<span>
											{this.state.filename}
										</span>
									</div>
									{this.state.search_type === 'date' ?
										<div className="col-xs-12" >
											<span>
												Información Del:  {this.state.start_date !== "" ?
													moment(this.state.start_date).format("DD/MM/YYYY")
												: ''}    
											</span>
											<span style={{marginLeft:"5px"}}>	
												Al: {this.state.end_date !== "" ?
													moment(this.state.end_date).format("DD/MM/YYYY")
												: ''}
											</span>
										</div>
									: null}

									
								</div>

								<div className="col-xs-12 form-group" id="table-to-pdf">									
									<div className="table-responsive">
										<table style={{fontSize:"11px"}} id="table-to-xls" width="100%" ref={el => this.el = el}>
										</table>
									</div>
								</div>
								<div className="col-xs-12">
									{this.state.totales.map((t, i)=>(
										<div style={{width:'10%', display:'inline-block'}}>
											<label>{t.code+': '}</label> <span>{t.total}</span>
										</div>
									))}
								</div>
								<div className="col-xs-12">
									<label>Donaciones: </label> <span>{this.state.total_don}</span>
								</div>
								<div className="col-xs-12 form-group">
									<label>Entradas Externas: </label> <span>{this.state.total_ext}</span>
								</div>
							</div>
						</form>
					</div>
				</div>

			</div>
		)
	}
}

export default translate('translations') (MadeCrio);